import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  return (
    <section className="w-full bg-background-100/50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,380px)_1fr] gap-8 lg:gap-16">
          <div>
            <SectionHeading
              eyebrow="FAQ"
              title="关于证据整理的常见问题"
              description="收录标准、来源标注与更新节奏，都在这里说明白。"
            />
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-background-200 text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部问答
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <FaqAccordion items={faqs.slice(0, 4)} defaultOpen={0} />
        </div>
      </div>
    </section>
  );
}